import { render, staticRenderFns } from "./TopLogo.vue?vue&type=template&id=925b34e2&scoped=true&"
import script from "./TopLogo.vue?vue&type=script&lang=js&"
export * from "./TopLogo.vue?vue&type=script&lang=js&"
import style0 from "./TopLogo.vue?vue&type=style&index=0&id=925b34e2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "925b34e2",
  null
  
)

export default component.exports